export type RenewFormMessages = {
  // Title
  yourDataTitle: string;
  paymentDataTitle: string;

  // Field Labels
  nameLabel: string;
  documentLabel: string;
  zipCodeLabel: string;
  addressLabel: string;
  numberLabel: string;
  complementLabel: string;
  neighborhoodLabel: string;
  cityLabel: string;
  stateLabel: string;
  cardNumberLabel: string;
  cardHolderLabel: string;
  cardExpiryLabel: string;
  cardCvvLabel: string;

  // Validation Messages
  errorRequiredName: string;
  errorRequiredCnpjCpf: string;
  errorRequiredCep: string;
  errorRequiredAddress: string;
  errorRequiredNumber: string;
  errorRequiredNeighborhood: string;
  errorRequiredCity: string;
  errorRequiredState: string;
  errorRequiredCardNumber: string;
  errorRequiredCardHolder: string;
  errorRequiredCardExpiry: string;
  errorRequiredCardCvv: string;
  invalidCardExpiry: string;

  // Additional Errors
  cepNotFoundError: string;

  // Button messages
  payButtonLabel: string;

  // Customer Sales Product Messages
  planRenewSuccess: string;
  planRenewError: string;
  existingPlanError: string;

  // Permission Error
  permissionErrorMessage: string;
};

export const RENEW_FORM_MESSAGES: RenewFormMessages = {
  // Title
  yourDataTitle: "OS SEUS DADOS",
  paymentDataTitle: "INFORMAÇÕES DE PAGAMENTO",

  // Field Labels
  nameLabel: "Nome / Razão Social",
  documentLabel: "CPF/CNPJ",
  zipCodeLabel: "CEP",
  addressLabel: "Endereço",
  numberLabel: "Número",
  complementLabel: "Complemento",
  neighborhoodLabel: "Bairro",
  cityLabel: "Cidade",
  stateLabel: "Estado",
  cardNumberLabel: "Número do Cartão",
  cardHolderLabel: "Nome Impresso no Cartão",
  cardExpiryLabel: "Validade",
  cardCvvLabel: "CVV",

  // Validation Messages
  errorRequiredName: "O campo é obrigatório",
  errorRequiredCnpjCpf: "O campo é obrigatório",
  errorRequiredCep: "O campo é obrigatório",
  errorRequiredAddress: "O campo é obrigatório",
  errorRequiredNumber: "O campo é obrigatório",
  errorRequiredNeighborhood: "O campo é obrigatório",
  errorRequiredCity: "O campo é obrigatório",
  errorRequiredState: "O campo é obrigatório",
  errorRequiredCardNumber: "O campo é obrigatório",
  errorRequiredCardHolder: "O campo é obrigatório",
  errorRequiredCardExpiry: "O campo é obrigatório",
  errorRequiredCardCvv: "O campo é obrigatório",
  invalidCardExpiry: "Data de validade do cartão inválida",

  // Additional Errors
  cepNotFoundError: "Digite um CEP Válido",

  // Button messages
  payButtonLabel: "Pagar Agora",

  // Customer Sales Product Messages
  planRenewSuccess: "Plano renovado com sucesso",
  planRenewError: "Erro ao renovar plano ",
  existingPlanError: "Você já possui um plano ativo para este produto de venda.",

  // Permission Error
  permissionErrorMessage:
    "Você não tem permissão para renovar planos. Somente administradores e gerentes podem realizar essa ação.",
};
